var Afiliate = /** @class */ (function () {
    function Afiliate(props) {
        Object.assign(this, props);
    }
    return Afiliate;
}());
export default Afiliate;
export var TypeCommission = {
    Fix: 'fix',
    Percentage: 'percentage'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Afiliates/Model.tsx
// module id = 330
// module chunks = 0